import fs from 'fs';
import path from 'path';

const DEFAULT_MAX_LINES = 1000;

export class PersistentHistory {
  private filePath: string;
  private maxLines: number;
  private lastEntry = '';

  constructor(filePath: string, maxLines = DEFAULT_MAX_LINES) {
    this.filePath = filePath;
    this.maxLines = maxLines;
  }

  load(): string[] {
    try {
      const content = fs.readFileSync(this.filePath, 'utf-8');
      const lines = content.split('\n').filter(Boolean);
      if (lines.length > this.maxLines) {
        const trimmed = lines.slice(lines.length - this.maxLines);
        fs.writeFileSync(this.filePath, trimmed.join('\n') + '\n', 'utf-8');
        return trimmed;
      }
      if (lines.length > 0) this.lastEntry = lines[lines.length - 1];
      return lines;
    } catch {
      return [];
    }
  }

  append(line: string): void {
    if (line === this.lastEntry) return;
    this.lastEntry = line;
    const dir = path.dirname(this.filePath);
    fs.mkdirSync(dir, { recursive: true });
    fs.appendFileSync(this.filePath, line + '\n', 'utf-8');
  }
}
